import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { IconArrowUp } from '../../../base/icons/svg';
import ToolboxButtonWithIcon from '../../../base/toolbox/components/web/ToolboxButtonWithIcon';
import { toggleClosedCaptionPopup } from '../../actions.web';
import { getClosedCaptionVisibility } from '../../functions';
import ClosedCaptionButton from './ClosedCaptionButton';
import ClosedCaptionButtonPopup from './ClosedCaptionButtonPopup';
/**
 * Button used for cc settings.
 *
 * @returns {ReactElement}
 */
class ClosedCaptionButtonWithPopup extends Component {
    /**
     * Initializes a new {@code ClosedCaptionButtonWithPopup} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this._onEscClick = this._onEscClick.bind(this);
        this._onClick = this._onClick.bind(this);
    }
    /**
     * Click handler for the more actions entries.
     *
     * @param {KeyboardEvent} event - Esc key click to close the popup.
     * @returns {void}
     */
    _onEscClick(event) {
        if (event.key === 'Escape' && this.props.isOpen) {
            event.preventDefault();
            event.stopPropagation();
            this._onClick();
        }
    }
    /**
     * Click handler for the more actions entries.
     *
     * @param {MouseEvent} e - Mouse event.
     * @returns {void}
     */
    _onClick(e) {
        const { onPopupClick, isOpen } = this.props;
        if (isOpen) {
            e?.stopPropagation();
        }
        onPopupClick();
    }
    /**
     * Implements React's {@link Component#render}.
     *
     * @inheritdoc
     */
    render() {
        const { buttonKey, isOpen, language, requestingSubtitles, visible, t, dispatch } = this.props;
        return visible ? (React.createElement(ClosedCaptionButtonPopup, null,
            React.createElement(ToolboxButtonWithIcon, { ariaControls: t('toolbar.accessibilityLabel.ccHistory'), ariaExpanded: isOpen, ariaHasPopup: true, ariaLabel: t('toolbar.accessibilityLabel.ccHistory'), buttonKey: buttonKey, icon: IconArrowUp, iconDisabled: false, iconId: 'closed-caption-button-icon', iconTooltip: t('toolbar.ccHistory'), onIconClick: this._onClick },
                React.createElement(ClosedCaptionButton, { _language: language, _requestingSubtitles: requestingSubtitles, _subtitles: language, dispatch: dispatch })))) : React.createElement(ClosedCaptionButton, { _language: language, _requestingSubtitles: requestingSubtitles, _subtitles: language, dispatch: dispatch });
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    const { isNarrowLayout } = state['features/base/responsive-ui'];
    const requesting = state['features/subtitles']._requestingSubtitles;
    const lang = state['features/subtitles']._language;
    return {
        isOpen: Boolean(getClosedCaptionVisibility(state)),
        language: lang,
        requestingSubtitles: requesting,
        subtitles: lang,
        visible: !isMobileBrowser() && !isNarrowLayout
    };
}
const mapDispatchToProps = {
    onPopupClick: toggleClosedCaptionPopup
};
export default translate(connect(mapStateToProps, mapDispatchToProps)(ClosedCaptionButtonWithPopup));
